import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/warning.svg'


const _hoisted_1 = { class: "text-12px xxl:text-14px py-6 space-y-2" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-36 mx-auto",
  alt: "warning"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "pb-2 space-y-2" }, [
  /*#__PURE__*/_createVNode("div", { class: "font-semibold text-center text-black-lp-200" }, " Konfirmasi Penolakan "),
  /*#__PURE__*/_createVNode("div", { class: "text-center text-black-lp-300 text-12px" }, " Masukan alasan penolakan transaksi top up. ")
], -1)
const _hoisted_4 = { class: "flex flex-row justify-center space-x-4 pt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_ModalForm = _resolveComponent("ModalForm")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_ModalForm, {
      modalWidth: "w-377px",
      customRound: "rounded-2xl",
      isFooter: false,
      isHeader: false,
      isScroll: false
    }, {
      content: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _hoisted_2,
          _hoisted_3,
          _createVNode(_component_lp_input, {
            type: "textarea",
            modelValue: _ctx.rejectReason,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.rejectReason = $event)),
            placeholder: "Masukan alasan penolakan"
          }, null, 8, ["modelValue"]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_LpButton, {
              onClick: _ctx.onBack,
              customClass: "px-10 py-2",
              textColor: "red-lp-100",
              title: "Kembali",
              outline: ""
            }, null, 8, ["onClick"]),
            (!_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_LpButton, {
                  key: 0,
                  disabled: _ctx.isDisableConfirm,
                  onClick: _cache[2] || (_cache[2] = () => (!_ctx.isDisableConfirm && !_ctx.isLoading ? _ctx.onReject() : {})),
                  customClass: "px-10 py-2 w-32",
                  textColor: "white",
                  title: "Update"
                }, null, 8, ["disabled"]))
              : (_openBlock(), _createBlock(_component_button_fill, {
                  key: 1,
                  custom: "bg-gray-lp-600 border border-gray-lp-600 text-white px-10 py-2",
                  title: "Update",
                  isLoading: true
                }))
          ])
        ])
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.showRejectModal && !_ctx.isSuccessSubmit]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: () => _ctx.onSubmit(),
      onClose: 
      () => {
        _ctx.showModalFormTopupRejection(true);
        _ctx.showConfirmModal = false;
      }
    ,
      title: "Konfirmasi Penolakan",
      message: 
      `Anda yakin akan menolak transaksi top up ${
        _ctx.selectedTopupApprovalList.partnerName
      } dengan jumlah ${_ctx.formatPrice(
        _ctx.selectedTopupApprovalList.verifiedAmount
      )} ?`
    ,
      image: "are-you-sure",
      textSuccess: "Reject",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "message"]), [
      [_vShow, _ctx.showConfirmModal]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: 
      () => {
        _ctx.setSuccessSubmit(false);
      }
    ,
      title: "Penolakan Berhasil !",
      message: `Permintaan top up berhasil ditolak.`,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.isSuccessSubmit]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.showDetail,
      onClose: 
      () => {
        _ctx.showCloseConfirmModal = false;
        _ctx.showModalFormTopupRejection(true);
      }
    ,
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.showCloseConfirmModal]
    ])
  ], 64))
}